/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.sailboat\":\"Two birds and a sailboat on water\"}");